import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { Injectable, inject } from '@angular/core';
import { OrdDetailsSecondaryActions } from './ord-details-secondary.actions';
import { OrdOrderI } from '../ord-search/models/ord-order.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingOrdDetails, loadingOrdDetailsSecondary } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class OrdDetailsSecondaryEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDetailsSecondaryActions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiOrdMethod.ordDetails, action.query))
            .pipe(
                map((result: OrdOrderI) => OrdDetailsSecondaryActions.received({
                    result,
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        OrdDetailsSecondaryActions.error({
                            error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDetailsSecondaryActions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingOrdDetailsSecondary
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDetailsSecondaryActions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingOrdDetailsSecondary
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdDetailsSecondaryActions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingOrdDetailsSecondary
            }),
        ]))
    );

}
